import { useEffect, useState } from 'react';
import { getChartOptions, selectChartRange } from '../chartOptionsSlice';
import { RangeRoutes } from './constants/RangeRoutes';
import { useDispatch, useSelector } from 'react-redux';
import DropDownButtonLegacy from 'common/components/drop-downs/legacy/dropDownButtonLegacy';
import { RootState } from 'app/store';
import SimpleButtonContainerContent from 'common/components/drop-downs/legacy/simpleDropDownButtonContainerContent';
import {
  isActivityTriggerNeeded,
  setSelectedDropDownItemAsActive
} from 'common/components/drop-downs/legacy/dropDownUtils';

const ChartDateRangeButton = ({
  chartId,
  defaultRange
}: {
  chartId: string;
  defaultRange: string;
}) => {
  const dispatch = useDispatch();
  const [rangeRoutes, setChartRangeRoutes] = useState(RangeRoutes);

  const { selectedChartRange } = useSelector((state: RootState) =>
    getChartOptions(state, chartId)
  );

  useEffect(() => {
    if (selectedChartRange === undefined && defaultRange !== undefined) {
      dispatch(selectChartRange({ chartId, selectedChartRange: defaultRange }));
    } else if (
      selectedChartRange !== undefined &&
      isActivityTriggerNeeded(rangeRoutes, selectedChartRange)
    ) {
      setChartRangeRoutes(
        setSelectedDropDownItemAsActive(rangeRoutes, selectedChartRange)
      );
    }
  }, [chartId, defaultRange, dispatch, rangeRoutes, selectedChartRange]);

  return (
    <DropDownButtonLegacy
      dropDownItems={rangeRoutes}
      selectDropDownItem={(key) =>
        dispatch(selectChartRange({ chartId, selectedChartRange: key }))
      }
    >
      <SimpleButtonContainerContent
        dropdownLabel="Range"
        additionalContainerStyling="bg-white rounded border border-neutral-200"
      />
    </DropDownButtonLegacy>
  );
};
export default ChartDateRangeButton;
